import { IconSettings } from '@tabler/icons-react';
import { APP_ROUTES } from '@zorro/common-utils';
import { Menu } from '@zorro/design-system/v2/Menu';
import { createImpersonationSession, useRoles } from '@zorro/web/ui-utils';

import { useAnalytics } from '../../Analytics';
import { ActionsSubMenu } from '../ActionsSubMenu';
import { ActionsMenuSection } from '../EmployeeActionsUtils';
import { EmployeeActionsOverlays } from '../employeeActions.consts';
import { resetPassword } from './accountManagement.utils';

type AccountManagementSectionProps = {
  recordsForActions: ActionsMenuSection['recordsForActions'];
  setOverlayId: ActionsMenuSection['setOverlayId'];
  isInEnrollmentsDatatable: boolean;
};

const AccountManagementSection = ({
  setOverlayId,
  recordsForActions,
  isInEnrollmentsDatatable,
}: AccountManagementSectionProps) => {
  const { isZorroOperations } = useRoles();
  const { sendEvent } = useAnalytics();

  const isBulk = recordsForActions.length > 1;

  return (
    <ActionsSubMenu title="Account management" icon={IconSettings}>
      {!isInEnrollmentsDatatable && (
        <Menu.Item
          onClick={() => {
            void sendEvent('click_action', {
              action_category: 'account_management',
              action_name: 'CHANGE_EMPLOYEE_ROLE',
            });
            setOverlayId(EmployeeActionsOverlays.CHANGE_EMPLOYEE_ROLE);
          }}
        >
          {EmployeeActionsOverlays.CHANGE_EMPLOYEE_ROLE}
        </Menu.Item>
      )}
      {!isBulk && (
        <>
          <Menu.Item
            onClick={() => {
              void sendEvent('click_action', {
                action_category: 'account_management',
                action_name: 'LOG_IN_AS',
              });
              createImpersonationSession(
                recordsForActions[0].employeeId,
                APP_ROUTES.HOME()
              );
            }}
          >
            Log in as
          </Menu.Item>

          {isZorroOperations && (
            <Menu.Item
              onClick={async () => {
                void sendEvent('click_action', {
                  action_category: 'account_management',
                  action_name: 'RESET_PASSWORD',
                });
                await resetPassword(recordsForActions[0].userId);
              }}
            >
              Reset password
            </Menu.Item>
          )}

          <Menu.Item
            onClick={() => {
              void sendEvent('click_action', {
                action_category: 'account_management',
                action_name: 'EDIT_COMPANY_EMAIL',
              });
              setOverlayId(EmployeeActionsOverlays.EDIT_COMPANY_EMAIL);
            }}
          >
            Edit company email
          </Menu.Item>
        </>
      )}
      {!isInEnrollmentsDatatable && (
        <Menu.Item
          onClick={() => {
            void sendEvent('click_action', {
              action_category: 'account_management',
              action_name: 'DELETE_EMPLOYEE',
            });
            setOverlayId(EmployeeActionsOverlays.DELETE_EMPLOYEE);
          }}
        >
          {isBulk ? 'Delete employees' : 'Delete employee'}
        </Menu.Item>
      )}
    </ActionsSubMenu>
  );
};

export { AccountManagementSection };
